import { Externalautomation } from 'data/firestore/agent/externalautomation/types';
import {
    AvatarContainer,
    NameLabel,
    StyledBuilding,
} from './styled';

interface ExternalAutomationInfoProps {
    externalautomation?: Externalautomation | null;
}

const ExternalAutomationInfo = ({
    externalautomation,
}: ExternalAutomationInfoProps) => (
    <AvatarContainer>
        <StyledBuilding />
        <NameLabel>
            {externalautomation?.name}
        </NameLabel>
    </AvatarContainer>
);

export default ExternalAutomationInfo;
